import { IFilterData } from './types';

export const normalizeFilterData = (data: IFilterData) => {
  return {
    fieldName: (data?.fieldName as string) || '',
    fieldValues: ((data?.fieldValues as string[]) || []).filter(
      (item) => item !== '' && item !== null,
    ),
  };
};
